export default __webpack_public_path__ + "static/media/parc2.9ab42c6e.png";